import { render, staticRenderFns } from "./form.vue?vue&type=template&id=5489cd67&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=5489cd67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489cd67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5489cd67')) {
      api.createRecord('5489cd67', component.options)
    } else {
      api.reload('5489cd67', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=5489cd67&scoped=true&", function () {
      api.rerender('5489cd67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/purchase/form.vue"
export default component.exports